import { AuthAction, AuthState, LOGIN_REQUEST, VERIFY_TOKEN, LOGIN_SUCCESS, LOGIN_FAILURE, lOGOUT_REQUEST, LOADING } from '../types/actions';

const initialState: AuthState = {
    user: null,
    authenticated: false,
    error: '',
    loading: null
}

const AuthReducer = (state = initialState, action: AuthAction) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return { ...state, user: { username: null, adminRole: null }, loading: true, error: '' }
        case LOGIN_SUCCESS:
            return { ...state, authenticated: true, user: action.payload, error: '' }
        case LOGIN_FAILURE:
            return { ...state, authenticated: false, error: action.payload, }
        case lOGOUT_REQUEST:
            return { ...state, authenticated: false, user: { username: null, adminRole: null }, loading: false, error: '' }
        case LOADING:
            return { ...state, loading: action.payload }
        case VERIFY_TOKEN:
            return { ...state, authenticated: action.payload }
        default:
            return state;
    }
}
export default AuthReducer;